'use strict';

import angular from 'angular';

import restButtonDirective from 'incidents/components/buttons/rest-button';
import {reverseUrl} from 'utils/django';

const MODULE_NAME = 'daupler.entities.ugSewer.components.buttons';

var app = angular.module(MODULE_NAME, []);
app.directive('ugSewerPauseCalls', restButtonDirective({method: 'POST', getUrl: getUrl('pause')}));
app.directive('ugSewerResumeCalls', restButtonDirective({method: 'POST', getUrl: getUrl('resume')}));

export default MODULE_NAME;


function getUrl(action) {
	return function($incident) {
		return reverseUrl(`incidents:daupler-entities-ug_sewer-form_team-${action}`, {
			uuid: $incident.uuid
		});
	};
}
